<template>
  <div>
    <threshold-input-form
      label="CH-A"
      dataKey="a"
      :upper="threshold.a_upper"
      :lower="threshold.a_lower"
      @update="$emit('update', $event)"
    ></threshold-input-form>
    <threshold-input-form
      label="CH-B"
      dataKey="b"
      :upper="threshold.b_upper"
      :lower="threshold.b_lower"
      @update="$emit('update', $event)"
    ></threshold-input-form>
    <threshold-input-form
      label="CH-C"
      dataKey="c"
      :upper="threshold.c_upper"
      :lower="threshold.c_lower"
      @update="$emit('update', $event)"
    ></threshold-input-form>
    <threshold-input-form
      label="CH-D"
      dataKey="d"
      :upper="threshold.d_upper"
      :lower="threshold.d_lower"
      @update="$emit('update', $event)"
    ></threshold-input-form>
  </div>
</template>

<script>
import ThresholdInputForm from "@/components/ThresholdInputForm";

export default {
  name: "Strain4chThresholdForm",
  components: { ThresholdInputForm },
  props: ["threshold"],
};
</script>
